import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";

export const SET_LISTA_SUBSTANICIAS = "setListsubstancias"
export const SET_MESSAGE_ALERT = 'setMensagem'

const actions = {

    //#region  substancia
    async create_substancia(context, value) {
        let message = await ApiService.post('substancia', value)
            .then(response => ({tipo: 'success', message: response.data}))
            .catch((error) => ({tipo: 'error', message: error.response.data}))
        context.commit(SET_MESSAGE_ALERT, message)
    },
    async update_substancia(context, value) {
        let message = await ApiService.put('substancia/atualizar', value)
            .then(response => ({tipo: 'success', message: response.data}))
            .catch((error) => ({tipo: 'error', message: error.response.data}))
        context.commit(SET_MESSAGE_ALERT, message)
    },
    async listar_substancias(context, params) {
        await ApiService.get('substancia')
            .then(response => context.commit(SET_LISTA_SUBSTANICIAS, response.data))
            .catch((error) => context.commit(SET_MESSAGE_ALERT, {
                tipo: 'error', message: error.response.data
            }))
    },
    async pesquisar_substancias(context, params) {
        await ApiService.get('substancia/pesquisar/'+params)
            .then(response => context.commit(SET_LISTA_SUBSTANICIAS, response.data))
            .catch((error) => context.commit(SET_MESSAGE_ALERT, {
                tipo: 'error', message: error.response.data
            }))
    },
    //#endregion

  
    

};

const getters = {};

const mutations = {
    [SET_LISTA_SUBSTANICIAS](state, value) {
        state.lista_substancias = value
    },
  

    [SET_MESSAGE_ALERT](state, value) {
        console.log(value)
        let customMessage;
        if (typeof value.message === "object") {
          customMessage = value.message.msg;
        }
        state.mensagem_alert = {
          tipo: value.tipo,
          message: customMessage ? customMessage : value.message,
        };
      },
};

const state = {
    lista_substancias: [],
    mensagem_alert: "",


};

export default {
    namespaced:true,
    state,
    actions,
    mutations,
    getters
};